import React from 'react';
import { assign } from 'xstate';
import { cloneDeep } from 'lodash';
import { Box } from '@mui/material';

import { MachineContext } from '../../MachineContext';
import { ValueCard, ValueCardProps } from '../ValueCard/ValueCard';
import { BaseComponent } from '../Component';
import { ValueCardSize } from '../ValueCard/ValueCardSizeEnums';
import { CardImageSize } from '../ObjectCard';

export interface ValueCardListComponent extends BaseComponent {
  type: 'valueCardList';
  props: ValueCardListProps;
}

// component Props
export interface ValueCardListProps {
  cards: ValueCardProps[];
  cardsPerRow?: number;
}

/**
 *
 */
export const ValueCardList: React.FC<ValueCardListProps> = ({
  cards,
  cardsPerRow = 3,
}) => {
  if (cardsPerRow < 1) {
    cardsPerRow = 1;
  }

  const hasDescription = cards && cards.length > 0 && cards[0].description;
  const numCols = cards.length / cardsPerRow;
  const colHeight =
    (cards.length > 0 && cards[0].imageSrc ? 300 : 200) -
    (hasDescription ? 0 : 50) +
    'px ';
  const colWidth = hasDescription ? '250px ' : '200px ';

  return (
    <Box
      sx={{
        display: 'grid',
        grid: colHeight.repeat(numCols) + '/ ' + colWidth.repeat(cardsPerRow),
      }}
    >
      {cards.map((card: ValueCardProps, index: number) => {
        return (
          <ValueCard
            isEcho
            cardSize={ValueCardSize.SMALL}
            description={card.description}
            image={card.image}
            imageSrc={card.imageSrc}
            imageSize={CardImageSize.SMALL}
            type={card.type}
            value={card.value}
            key={'hotechocard_' + index}
          />
        );
      })}
    </Box>
  );
};

export const renderValueCardListAction = assign(
  (context: MachineContext, _event, actionMetadata) => {
    const newContext = cloneDeep(context);
    newContext.widgetData = newContext.widgetData.filter(
      (element) => !element.temporary
    );
    const payload = actionMetadata.action.payload;

    const cards = payload.getValueFrom
      ? context.userData[payload.getValueFrom]
      : [];

    newContext.widgetData.push({
      type: 'valueCardList',
      temporary: actionMetadata.action.temporary ?? false,
      props: {
        cards: cards,
        cardsPerRow: payload.cardsPerRow ?? 3,
      },
    });
    return newContext;
  }
);
